import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

import {featureInterface} from "../../../../../interfaces/featureInterface";
import {getDbFeatureProperty, shouldUseLixilAvailableQty} from "../../lookFunctions2";
import {setGroheActiveFeatureQuantity} from "../../../../../actions/groheFunctions";


const LookWizardSectionListFeatureQuantity = (props) => {

  const {listFeatureClick, lookFeature, intl, fabricatorSettings, wizardSelectedValues, wizardActiveStep,
    setGroheActiveFeatureQuantity} = props;

  const selectedWizValue = wizardSelectedValues[wizardActiveStep];
  const currentStepQuantityItems = selectedWizValue?.quantityItems || [];

  const foundSelectedQuanItem = currentStepQuantityItems.find(q => {
    return q.quanFeature.dbFeature.id === lookFeature.dbFeature.id
  });

  const useLixilQuantity = shouldUseLixilAvailableQty(fabricatorSettings, foundSelectedQuanItem ? foundSelectedQuanItem.quanFeature : null);

  const quantity = foundSelectedQuanItem?.quantity || 0;

  const MAX = foundSelectedQuanItem?.quanFeature && foundSelectedQuanItem.quanFeature.dbFeature[getDbFeatureProperty("lixilAvailableQty")] > 0
    ? foundSelectedQuanItem.quanFeature.dbFeature[getDbFeatureProperty("lixilAvailableQty")]
    : 99999;
  const MIN = 0;

  const allowDecimals = false;
  const featureIsInStock = true;

  // const handleInputChange = (e, fromButton = "") => {
  const handleInputChange = (e) => {

    e.stopPropagation(); // prevent parent from handling the event (original click event)

    let value = "" + e.target.value;

    if (value.includes(".")) {
      if (!allowDecimals) {
        return false
      }
      if (value.split(".")[1].length > 2) {
        value = +value.substring(0, value.length - 1); //round to 2 decimals
      }
    }

    value = parseInt(value) || 0;

    if (value <= MAX) {
      value = value < MIN ? MIN : value;
    } else if (value !== MAX) {
      value = MAX
    }

    // const featureLabel = Analytics.getSkuForAnalytics(cartItem.cartFeature);
    // const analyticsAdjust = fromButton ? fromButton + "-" + value : "input-" + value;
    // Analytics.sendClickEvent(`${LOOK_JOURNEY_ANALYTIC_EVENTS.lookListCartItemQuantityChange + featureLabel}-${analyticsAdjust}`);

    const newQuanItem = {
      quanFeature: lookFeature,
      quantity: value,
    }

    let newArray = [...currentStepQuantityItems];
    let index = newArray.findIndex(quanItem => quanItem.quanFeature.dbFeature.id === lookFeature.dbFeature.id);
    (index >= 0) ? newArray[index] = newQuanItem : newArray.push(newQuanItem);

    listFeatureClick(e, newArray);

    if (selectedWizValue?.selectedFeature?.dbFeature.id === lookFeature.dbFeature.id) {
      setGroheActiveFeatureQuantity(value);
    }
  };

  const handleOnKeyDown = (event) => {
    if (event.key==='.' && !allowDecimals) {
      event.preventDefault();
      return false
    }
  };

  return (
    <div className="ll-quantity ll-quantity--no-text">
      <div className="ll-quantity__actions">
        {useLixilQuantity && (quantity === MAX) ? (
          <span className="lm-stock lm-stock--red ll-quantity__max-stock">
            <FormattedMessage values={{quantity: MAX}} id="look.list.feature.maxStock"/>
          </span>
        ) : null}
        <div className={"grohe-quantity " + (!featureIsInStock ? "grohe-quantity--disabled" : "")}>
          <div className="grohe-quantity__container">
            <IconButton aria-label={intl.formatMessage({id:"look.list.header.printButton"})}
                        // disabled={!featureIsInStock}
                        onClick={(e) => {
                          e.target.value = quantity - 1;
                          handleInputChange(e);
                        }}
                        className={"look-icon grohe-look__icon--small look-icon--small"}>
              <RemoveIcon />
            </IconButton>
            <TextField className={"grohe-quantity__input" + (quantity === MAX ? " ll-quantity__input--red" : "")}
                       label=""
                       variant="outlined"
                       size="small"
                       type="number"
                       value={quantity}
                       pattern="^\d+(?:\.\d{1,2})?$"
                       onKeyDown={handleOnKeyDown}
                       onChange={handleInputChange}/>
            <IconButton aria-label={intl.formatMessage({id:"look.list.header.printButton"})}
                        disabled={quantity === MAX || !featureIsInStock}
                        onClick={(e) => {
                          e.target.value = quantity + 1;
                          handleInputChange(e);
                        }}
                        className={"look-icon grohe-look__icon--small look-icon--small"}>
              <AddIcon />
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  )
};

LookWizardSectionListFeatureQuantity.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
  wizardStepIndex: PropTypes.number,
  // featureGroup: PropTypes.object,
  // viewType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // wizardGroup: PropTypes.shape(wizardGroupInterface),
}

const mapStateToProps = (store, ownProps) => {
  const {lookViewType} = store.lookState;
  const {wizardSelectedValues, wizardActiveStep} = store.wizardState;

  return {
    lookViewType,
    fabricatorSettings: store.fabricatorState.settings,
    wizardActiveStep: ownProps.wizardStepIndex || wizardActiveStep,
    wizardSelectedValues,
  };
};

const mapDispatchToProps = {
  // addToCart,
  // setWizardSelectedValues,
  // changeCartItemQuantity,
  setGroheActiveFeatureQuantity,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardSectionListFeatureQuantity)
)
